import React, { useContext, useEffect, useMemo } from "react";
import Quotes from "../Quote/QuoteDashboard";
import Administration from "../Administration";
import UserContext from "../../context/user/UserContext";
import ProductCatalog from "../ProductCatalog";
import Loading from "../UI/Loading";
import PagerContextProvider from "../UI/Pager/PagerContext";
import Configurator from "../Configurator";
import Login from "../Login";

const HomePage = (props) => {
  const { activeUser, isLoading } = useContext(UserContext);
  const { roleLevel = 0 } = activeUser || {};

  const Component = useMemo(() => {
    if (isLoading) return <Loading />;
    switch (roleLevel) {
      case 0:
        return <Login />;
      case 3:
        return (
          <PagerContextProvider defaultOrder={["Name", "ASC"]}>
            <ProductCatalog {...props} pageView />
          </PagerContextProvider>
        );

      case 9:
        return <Quotes />;

      default:
        return <Quotes />;
    }
  }, [isLoading, props, roleLevel]);

  useEffect(() => {}, [isLoading, roleLevel]);

  return Component;
};

export default HomePage;
